export const DEFAULT_MENU_CATEGORIES = [
  "Main",
  "Starter",
  "Dessert",
  "Drinks",
  "Sides",
  "Specials",
];

const CATEGORY_BADGE_CLASSES = [
  "bg-slate-100 text-slate-700",
  "bg-blue-100 text-blue-700",
  "bg-emerald-100 text-emerald-700",
  "bg-amber-100 text-amber-700",
  "bg-rose-100 text-rose-700",
  "bg-violet-100 text-violet-700",
  "bg-cyan-100 text-cyan-700",
];

export function normalizeMenuCategories(categories) {
  const cleaned = [];
  const seen = new Set();

  for (const value of Array.isArray(categories) ? categories : []) {
    const normalized = `${value ?? ""}`.trim();
    const lowered = normalized.toLowerCase();
    if (!normalized || seen.has(lowered)) continue;
    seen.add(lowered);
    cleaned.push(normalized);
  }

  return cleaned;
}

export function getMenuCategories(restaurant, extraCategories = []) {
  const configured = normalizeMenuCategories(restaurant?.menu_categories);
  const base = configured.length > 0 ? configured : DEFAULT_MENU_CATEGORIES;
  return normalizeMenuCategories([...base, ...extraCategories]);
}

export function getDefaultMenuCategory(categories = []) {
  return normalizeMenuCategories(categories)[0] || DEFAULT_MENU_CATEGORIES[0];
}

export function getCategoryColorClass(category) {
  const text = `${category ?? ""}`.trim();
  if (!text) return CATEGORY_BADGE_CLASSES[0];

  let hash = 0;
  for (let i = 0; i < text.length; i += 1) {
    hash = (hash * 31 + text.charCodeAt(i)) >>> 0;
  }
  return CATEGORY_BADGE_CLASSES[hash % CATEGORY_BADGE_CLASSES.length];
}

export function getCategoryTabValue(category) {
  const normalized = `${category ?? ""}`
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

  return `category-${normalized || "general"}`;
}
